import { IApps } from '../../component/orchestrator/apps/interfaces/apps';
import { get } from '../utility/Requests.default';

export const appsUrl = `/api/orchestrator/apps`;

export default function getApps(accountLogicalName: string) {
    return get<IApps[]>(appsUrl, { urlParams: { accountLogicalName } });
}
